export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-4-59cc538bd5749f76865912059d43d6b0.webp";